// Allowlist validators for embedded media in blog content. DOMPurify hooks in
// BlogRenderer call these; kept pure so the policy itself is unit-testable.
const YOUTUBE_EMBED_PREFIXES = [
  "https://www.youtube-nocookie.com/embed/",
  "https://www.youtube.com/embed/",
];

export function isAllowedEmbedSrc(src: string | null | undefined): boolean {
  if (!src) return false;
  return YOUTUBE_EMBED_PREFIXES.some((p) => src.startsWith(p));
}

export function isAllowedVideoSrc(src: string | null | undefined): boolean {
  if (!src) return false;
  return src.startsWith("/uploads/") && !src.includes("..");
}
